import * as firebase from 'firebase';
import {
    FETCH_ADMINS,
    FETCH_ADMINS_FAILED,
    FETCH_ADMINS_SUCCESSFUL, FETCH_CLIENT_USERS_FAILED, FETCH_CLIENT_USERS_SUCCESSFUL,
    FETCH_SYSTEM_INFO_FAILED,
    FETCH_SYSTEM_INFO_SUCCESSFUL,
    SET_INITIAL_SEETINGS,
    SET_INITIAL_SEETINGS_FAILED,
    SET_INITIAL_SEETINGS_SUCCESSFUL,
} from "./Types";

//property declarations
// const retrievedProject = localStorage.getItem('churchInitializedProject');
// let project = {};
// if (retrievedProject) {
//     project = JSON.parse(retrievedProject);
// }

//property declaration
//const XLSX = require('xlsx');

export const fetchAdmins = () => {

    return(dispatch) => {
        getAdmins({ dispatch });
    };
};

export function getAdmins({ dispatch }) {
    dispatch({ type: FETCH_ADMINS });
    firebase.firestore().collection("adminBucket")
        .onSnapshot(function(querySnapshot) {
            //create admin array bucket
            const admins = [];

            querySnapshot.forEach(function(doc) {
                const data = doc.data();
                admins.push(data);
            });

            dispatch({
                type: FETCH_ADMINS_SUCCESSFUL,
                payload: admins
            })
        }, function (error) {
            console.log("couldn't fetch admins");
            console.log(error);
            dispatch({ type: FETCH_ADMINS_FAILED })
        });
}

export const fetchClientUsers = () => {
    return(dispatch) => {
        firebase.firestore().collection("userBucket")
            .onSnapshot(snapshot => {
                if (snapshot.size === 0) {
                    dispatch({
                        type: FETCH_CLIENT_USERS_FAILED,
                    });
                } else {
                    let clientUsers = [];
                    snapshot.forEach(doc => {
                        const data = doc.data();
                        clientUsers.push(data);
                    });

                    dispatch({
                        type: FETCH_CLIENT_USERS_SUCCESSFUL,
                        payload: clientUsers
                    });
                }
            }, function (e) {
                console.log(e);
                dispatch({
                    type: FETCH_CLIENT_USERS_FAILED,
                });
            })
    }
}


export const fetchSystemInfo = () => {
    return(dispatch) => {
        firebase.firestore().collection("system").doc("info")
            .onSnapshot(function (doc) {
                if (doc.exists) {
                    const data = doc.data();
                    dispatch({
                        type: FETCH_SYSTEM_INFO_SUCCESSFUL,
                        payload: data
                    });
                } else {
                    dispatch({ type: FETCH_SYSTEM_INFO_FAILED })
                }
            }, function (error) {
                dispatch({ type: FETCH_SYSTEM_INFO_FAILED });
                console.log(error);
            })
    }
};

export const setInitialSettings = ({ exchangeRate }) => {
    return(dispatch) => {
        dispatch({ type: SET_INITIAL_SEETINGS });
        firebase.firestore().collection("system").doc("info")
            .get()
            .then((doc) => {
                if (doc.exists) {
                    firebase.firestore().collection("system").doc("info")
                        .update({ exchangeRate, migration: true })
                        .then(() => {
                            console.log("initial settings update successful");
                            dispatch({
                                type: SET_INITIAL_SEETINGS_SUCCESSFUL
                            })
                        })
                        .catch((error) => {
                            dispatch({ type: SET_INITIAL_SEETINGS_FAILED });
                            console.log("initial settings update failed");
                            console.log(error);
                        })
                } else {
                    firebase.firestore().collection("system").doc("info")
                        .set({ exchangeRate, migration: true })
                        .then(() => {
                            console.log("initial settings set successful");
                            dispatch({
                                type: SET_INITIAL_SEETINGS_SUCCESSFUL
                            })
                        })
                        .catch((error) => {
                            dispatch({ type: SET_INITIAL_SEETINGS_FAILED });
                            console.log("initial settings set failed");
                            console.log(error);
                        })
                }
            })
    };
};
